import { render } from "./ingredientCategories.vue?vue&type=template&id=1c4e946e&scoped=true&ts=true"
import script from "./ingredientCategories.vue?vue&type=script&lang=ts"
export * from "./ingredientCategories.vue?vue&type=script&lang=ts"

import "./ingredientCategories.vue?vue&type=style&index=0&id=1c4e946e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4e946e"]])

export default __exports__